var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotePanel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 7.50004H5.83333V5.83337H14.1667V7.50004ZM14.1667 10.8334H5.83333V9.16671H14.1667V10.8334ZM11.6667 14.1667H5.83333V12.5H11.6667V14.1667ZM10 2.50004C10.221 2.50004 10.433 2.58784 10.5893 2.74412C10.7455 2.9004 10.8333 3.11236 10.8333 3.33337C10.8333 3.55439 10.7455 3.76635 10.5893 3.92263C10.433 4.07891 10.221 4.16671 10 4.16671C9.77899 4.16671 9.56702 4.07891 9.41074 3.92263C9.25446 3.76635 9.16667 3.55439 9.16667 3.33337C9.16667 3.11236 9.25446 2.9004 9.41074 2.74412C9.56702 2.58784 9.77899 2.50004 10 2.50004V2.50004ZM15.8333 2.50004H12.35C12 1.53337 11.0833 0.833374 10 0.833374C8.91667 0.833374 8 1.53337 7.65 2.50004H4.16667C3.72464 2.50004 3.30072 2.67564 2.98816 2.9882C2.67559 3.30076 2.5 3.72468 2.5 4.16671V15.8334C2.5 16.2754 2.67559 16.6993 2.98816 17.0119C3.30072 17.3244 3.72464 17.5 4.16667 17.5H15.8333C16.2754 17.5 16.6993 17.3244 17.0118 17.0119C17.3244 16.6993 17.5 16.2754 17.5 15.8334V4.16671C17.5 3.72468 17.3244 3.30076 17.0118 2.9882C16.6993 2.67564 16.2754 2.50004 15.8333 2.50004Z",
    fill: "url(#paint0_linear_676_473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_473",
    x1: 5.70755,
    y1: -13.4782,
    x2: 30.9325,
    y2: 2.28499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536953,
    stopColor: "#FF695C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF475E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotePanel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note_panel.5afa9a4c86932a0c8965ff7daa54f9ff.svg";